// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"306":"ffc70586","340":"5ff44116","498":"101d8a9e","509":"6bce9c6d","938":"699f0601"}[chunkId] + ".chunk.js";
};